import { API_BASE } from "../config";
import { idBDDesdePlantel } from "./plantel";

// Nombres de plantel tal como estan en la BD (tblcentrosdetrabajo, sin la palabra "CECYTEJ"), para el PDF de la
// orden de pago. Se piden una sola vez por visita a wMultipagosObtenerPlantelesPublico.php (no pide sesion: lo
// usa tambien el alumno). Si el servidor no contesta, se regresa {} y el PDF usa su lista de respaldo.
const TIEMPO_MAXIMO_MS = 4000;
let pendiente = null;

const pedir = async () => {
  if (typeof fetch !== "function") return {};
  const controlador = typeof AbortController === "function" ? new AbortController() : null;
  const temporizador = controlador ? setTimeout(() => controlador.abort(), TIEMPO_MAXIMO_MS) : null;
  try {
    const r = await fetch(`${API_BASE}/wMultipagosObtenerPlantelesPublico.php`, controlador ? { signal: controlador.signal } : undefined);
    const datos = await r.json();
    const nombres = {};
    if (datos && datos.success && Array.isArray(datos.data)) {
      datos.data.forEach((p) => {
        const nombre = String(p.nombre_plantel || "").trim();
        if (nombre) nombres[String(p.id)] = nombre;
      });
    }
    return nombres;
  } catch (error) {
    return {};
  } finally {
    if (temporizador) clearTimeout(temporizador);
  }
};

// { idBD: nombre }. Si falla, la siguiente llamada lo vuelve a intentar.
export const obtenerNombresPlanteles = async () => {
  if (!pendiente) pendiente = pedir();
  const nombres = await pendiente;
  if (!Object.keys(nombres).length) pendiente = null;
  return nombres;
};

// Nombre del plantel oficial ("07") segun la BD; "" si no se pudo obtener.
export const nombrePlantelDeBD = async (plantelOficial) => {
  if (!plantelOficial) return "";
  const nombres = await obtenerNombresPlanteles();
  return nombres[idBDDesdePlantel(plantelOficial)] || "";
};

// Solo para pruebas
export const _reiniciarNombresPlanteles = () => { pendiente = null; };
